/* src/components/project-tis-quickscan/project-tis-quickscan.component.scss */
:host {
  display: block;
  --table-border-size: 1px;
}
.main-wrapper {
  padding-top: 2rem;
}
.tis-quickscan {
  padding-left: var(--vwui-size-component-nav);
}
/*# sourceMappingURL=project-tis-quickscan.component-FCEFWBWN.css.map */
